import { render, staticRenderFns } from "./UploadModalVertify.vue?vue&type=template&id=13f0208f&scoped=true"
import script from "./UploadModalVertify.vue?vue&type=script&lang=js"
export * from "./UploadModalVertify.vue?vue&type=script&lang=js"
import style0 from "./UploadModalVertify.vue?vue&type=style&index=0&id=13f0208f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0208f",
  null
  
)

export default component.exports